import { SortableTree } from 'dnd-kit-sortable-tree';
import { Button } from '../../../../../../components/button/button';
import { DeleteTreeStructureModal } from './delete-tree-structure-modal/delete-tree-structure-modal';
import { TreeStructureNode } from './tree-structure-node/tree-structure-node';
import s from './tree-structure.module.css';
import { useTreeStructure } from './use-tree-structure';
import { Card } from '../../../../../../components/card/card';

export const TreeStructure = () => {
  const { handleSave, nodes, updateTree, handleCloseModal, isOpen, t, isLoading } =
    useTreeStructure();

  return (
    <Card className={s.feature}>
      <h3 className={s.title}>
        3. {t('Структура')}
        <div className={s.controls}>
          <Button hrefBack variant="secondary" data-testid="cancel-tree">
            {t('Назад')}
          </Button>
          <Button
            onClick={handleSave}
            className={s.save}
            disabled={isLoading}
            data-testid="submit-tree"
          >
            {t('Сохранить')}
          </Button>
        </div>
      </h3>
      <ul className={s.list}>
        <SortableTree
          items={nodes || []}
          onItemsChanged={updateTree}
          TreeItemComponent={TreeStructureNode}
        />
      </ul>

      {isOpen && (
        <DeleteTreeStructureModal onClose={() => handleCloseModal(['name', 'deleteId'])} />
      )}
    </Card>
  );
};
